export class SecurityQuestionRequest {
    Id: number;
    IdUser: string;
    IdQuestion: number;
    Question: string;
    Response: string;
}